import { httpClient } from "../../../shared/api/httpClient"
import { ordenarPorNombre } from "../../../shared/utils/funciones"
import { conCacheSesion } from "../../../shared/api/cacheSesion"
import type {
    CompaniasYSucursalesResult,
    GruposPorUsuarioRequest,
    GruposUsuarioResult,
    RutasDeAccesoRequest,
    RutasDeAccesoResult,
    TokenRequest,
    UsuarioAsignarGruposRequest,
    UsuarioSimpleResult,
} from "../types/usuarios.types"

export const usuarioAsignarGrupos = async (dataPOST: UsuarioAsignarGruposRequest): Promise<UsuarioSimpleResult | undefined> => {
    try {

        const res = await httpClient.post("api/usuario/AddUserGroup", dataPOST)
        //res.status 201
        if (res.data.status === 1) {
            return {
                status: res.data.status,
                message: res.data.message,
            }
        }

    } catch (error) {

        if (error.response && error.response.data.status === 0) {

            return {
                status: error.response.data.status,
                message: error.response.data.message,
            };
        }

        return {
            status: -1,
            message: "Error en el servidor",
        }
    }
}

export const grupoMostrarGruposPorUsuario = async (dataPOST: GruposPorUsuarioRequest): Promise<GruposUsuarioResult | undefined> => {
    try {
        const res = await httpClient.post("api/usuario/MostrarUserGroup", dataPOST)

        //res.status 201
        if (res.data.status === 1) {
            return {
                status: res.data.status,
                message: res.data.message,
                grupos: res.data.lista_grupo
            }
        }

    } catch (error) {

        if (error.response && error.response.data.status === 0) {
            return {
                status: error.response.data.status,
                message: error.response.data.message,
                grupos: []
            };
        }

        return {
            status: -1,
            message: "Error en el servidor",
            grupos: []
        }
    }
}


// Esta api funciona tanto para master y usuario normal.
// Los catálogos del usuario (companías/sucursales/sedes) son constantes durante la sesión y
// TODAS las páginas los piden al montar -> se cachean por token (dedup + evita re-consultar
// la misma API en cada navegación). Ver shared/api/cacheSesion.
export const usuarioObtenerCompaniasYSucursales = (dataPOST: TokenRequest): Promise<CompaniasYSucursalesResult | undefined> =>
    conCacheSesion(
        `xsede:${(dataPOST as any)?.token}`,
        async () => {
            try {
                const res = await httpClient.post("api/usuario/UsuarioXSede", dataPOST)
                //res.status 201
                if (res.data.status === 1) {
                    // Catálogos ordenados alfabéticamente para todos los selects (filtros y formularios).
                    return {
                        status: res.data.status,
                        message: res.data.message,
                        companias: ordenarPorNombre(res.data.compania),
                        sucursales: ordenarPorNombre(res.data.sucursales),
                        sedes: ordenarPorNombre(res.data.sedes)
                    }
                }
            } catch (error) {
                if (error.response && error.response.data.status === 0) {
                    return {
                        status: error.response.data.status,
                        message: error.response.data.message,
                        companias: [],
                        sucursales: [],
                        sedes: []
                    };
                }
                return {
                    status: -1,
                    message: "Error en el servidor",
                    companias: [],
                    sucursales: [],
                    sedes: []
                }
            }
        },
        (v) => (v as any)?.status === 1,
    )

export const usuarioObtenerRutasDeAcceso = async (dataPOST: RutasDeAccesoRequest): Promise<RutasDeAccesoResult | undefined> => {
    try {

        const res = await httpClient.post("api/usuario/RutaPlana", dataPOST)

        //res.status 201
        if (res.data.status === 1) {
            return {
                status: res.data.status,
                message: res.data.message,
                rutas : res.data.ruta_plana
            }
        }

    } catch (error) {

        if (error.response && error.response.data.status === 0) {
            return {
                status: error.response.data.status,
                message: error.response.data.message,
                rutas : []
            };
        }

        return {
            status: -1,
            message: "Error en el servidor",
            rutas: []
        }
    }
}
